import { refs, domReady, dispatchEvent } from '../modules/utils.js';
import { createTimeline, stagger } from 'animejs';

class LayoutOverlay extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    document.addEventListener('iconinfo:click', () => this.#tweenIn());
    document.addEventListener('videowrapper:click', () => this.#tweenIn());
    document.addEventListener('iconclose:click', () => this.#tweenOut());
  }

  #tweenIn() {
    dispatchEvent('layoutoverlay:in');

    const timeline = createTimeline({
      onBegin: () => this.classList.add('display')
    });


    timeline.add(
      this.refs.content,
      {
        opacity: 1,
        translateY: ['100dvh', '0'],
        ease: 'cubicBezier(.37,.75,.66,1)',
        duration: 1100
      },
      0
    );

    timeline.add(
      this.refs.content.children,
      {
        opacity: 1,
        translateY: ['10rem', '0'],
        ease: 'outQuad',
        duration: 800,
        delay: stagger(100, { start: 0 }),
        onComplete: (instance) => {
          this.refs.content.classList.add('display');
        }
      },
      0
    );
  }

  #tweenOut() {
    dispatchEvent('layoutoverlay:out');

    const timeline = createTimeline({
      onComplete: () => this.classList.remove('display')
    });

    timeline.add(
      this.refs.content,
      {
        opacity: 0,
        ease: 'cubicBezier(.37,.75,.66,1)',
        duration: 1000,
      },
      0
    );

    timeline.add(
      this.refs.content.children,
      {
        opacity: 0,
        translateY: '-10rem',
        ease: 'inQuad',
        duration: 600,
        delay: stagger(50, { start: 0 }),
        onComplete: (instance) => {
          this.refs.content.classList.remove('display');
        }
      },
      0
    );
  }
}

customElements.define('layout-overlay', LayoutOverlay);
